// VBS Event Schedule Details
export const vbsSchedule = {
  mainEvent: {
    name: "Vacation Bible School",
    dates: "July 13-17",
    startDate: "2025-07-13",
    endDate: "2025-07-17",
    time: "6:00 PM - 8:00 PM",
    startTime: "6:00 PM",
    endTime: "8:00 PM",
  },
  saturdayProgram: {
    name: "Saturday Program",
    date: "July 18",
    startDate: "2025-07-18",
    time: "9:45 AM - 12:30 PM",
    startTime: "9:45 AM",
    endTime: "12:30 PM",
  },
  volunteerInfo: {
    arrivalTime: "5:30 PM",
    arrivalNote: "Volunteers should arrive 30 minutes early",
    mainEventArrival: "5:30 PM on July 13-17",
  },
};
